import React, {useEffect, useState} from "react";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {useTranslate} from "../../system/useTranslate";
import Icon from "../../system/components/icon";
import InputLabel from "../../system/components/input-label";
import {RichTextEditor} from "../../system/components/rich-text";

function Header({dashboard}) {
    const translate = useTranslate();
    return (
        <div className="flex flex-column">
            <span className="text-lg">{translate(dashboard ? "reports.dashboard.dialog.editTitle" : "reports.dashboard.dialog.createTitle")}</span>
            <span className="text-xs text-400">{dashboard?.title}</span>
        </div>
    );
}

function Footer({setVisible, onSubmit, loading}) {
    const translate = useTranslate();
    return (
        <div className="flex flex-row-reverse align-items-center gap-2 justify-content-start p-3 surface-50 border-round-bottom-2xl border-top-1 border-300">
            <Button
                icon={<Icon icon="mi mi:save" className="text-lg"/>}
                className="text-xs flex gap-2 border-round-lg p-2"
                label={translate("save-changes")}
                loading={loading}
                onClick={onSubmit}
            />
            <Button
                className="text-xs p-button-secondary p-button-outlined border-round-lg p-2"
                label={translate("cancel")}
                onClick={() => setVisible(false)}
            />
        </div>
    );
}

function ReportDashboardDialog({visible, setVisible, dashboardData, onSubmit, loading = false}) {
    const translate = useTranslate();
    const [formData, setFormData] = useState({});

    useEffect(() => {
        if (visible) {
            setFormData({
                title: dashboardData?.title || "",
                description: dashboardData?.description || "",
            });
        }
    }, [visible, dashboardData]);

    const submit = () => {
        onSubmit?.({
            value: {
                title: formData.title,
                description: formData.description,
            },
            payload: formData,
        });
    };

    return (
        <Dialog
            pt={{footer: () => ({className: "p-0 border-round-bottom-2xl"}), content: () => ({className: "p-0 h-full"})}}
            header={<Header dashboard={dashboardData}/>}
            contentClassName="p-4"
            headerClassName="border-round-top-2xl border-bottom-1 border-300 pb-3 pt-3"
            footer={<Footer setVisible={setVisible} onSubmit={submit} loading={loading}/>}
            className="rtl w-11 md:w-6 border-round-bottom-2xl"
            visible={visible}
            onHide={() => setVisible(false)}>
            <div className="flex flex-column gap-3">
                <InputText
                    placeholder={translate("reports.dashboard.dialog.titlePlaceholder")}
                    className="flex-1 border-none shadow-none text-xl"
                    value={formData.title || ""}
                    onChange={(event) => setFormData({...formData, title: event.target.value})}
                />
                <InputLabel className="flex-1" label={translate("reports.dashboard.dialog.descriptionLabel")}>
                    <RichTextEditor
                        placeholder={translate("reports.dashboard.dialog.descriptionPlaceholder")}
                        value={formData.description || ""}
                        onChange={(html) => setFormData((current) => ({...current, description: html}))}
                        minHeight="5rem"
                    />
                </InputLabel>
            </div>
        </Dialog>
    );
}

export default ReportDashboardDialog;
